import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const MobileAppPromo = memo(function MobileAppPromo() {
  return <div className="container mx-auto px-4 py-8" data-id="element-2427" data-mp="xnkqpsh9eqii">
      <div className="bg-[#2B59C3] rounded-[32px] overflow-hidden shadow-xl relative" data-id="element-2428" data-mp="sn6edy8mkueo">
        {/* Background decorative elements */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-white/5 rounded-l-full transform translate-x-1/3 -translate-y-1/4 pointer-events-none" data-id="element-2429" data-mp="okjk7qohexeb"></div>

        <div className="flex flex-col md:flex-row items-center p-8 md:p-16 gap-12 relative z-10" data-id="element-2430" data-mp="job7ejxrbgab">
          {/* Left Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-2431" data-mp="9vx61salcboo">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4 leading-tight" data-id="element-2432" data-mp="9ucabzcjimp8">
              Download The <br data-id="element-2433" data-mp="4vrcu7ooah4h" />
              <span className="text-[#FFD700]" data-id="element-2434" data-mp="vqtq9qmphr3">LIFE APP NOW</span>
            </h2>
            <p className="text-blue-100 text-base md:text-lg mb-8 max-w-md mx-auto md:mx-0" data-id="element-2435" data-mp="3s2bhnkle09jw">
              For better experience download our app! Get exclusive offers and
              track your orders in real-time.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-4" data-id="element-2436" data-mp="xbhjey21qiay">
              <button className="bg-black text-white px-6 py-3 rounded-xl flex items-center gap-3 hover:scale-105 transition-transform shadow-xl" data-id="element-2437" data-mp="jkco285poc6f">
                <div className="text-left" data-id="element-2438" data-mp="nlo5vricft42">
                  <div className="text-[10px] uppercase opacity-80" data-id="element-2439" data-mp="1bb8sckdph8i3">
                    Download on the
                  </div>
                  <div className="text-base font-bold" data-id="element-2440" data-mp="1g90pbst7jkt5">App Store</div>
                </div>
              </button>
              <button className="bg-black text-white px-6 py-3 rounded-xl flex items-center gap-3 hover:scale-105 transition-transform shadow-xl" data-id="element-2441" data-mp="129spcxp808nw">
                <div className="text-left" data-id="element-2442" data-mp="3n0t6t77muw64">
                  <div className="text-[10px] uppercase opacity-80" data-id="element-2443" data-mp="3mzqjf99irbuy">
                    Get it on
                  </div>
                  <div className="text-base font-bold" data-id="element-2444" data-mp="3rxjlpr7pblpy">Google Play</div>
                </div>
              </button>
            </div>
          </div>

          {/* Right Content - App Preview */}
          <div className="flex-1 relative w-full max-w-md mx-auto mt-8 md:mt-0" data-id="element-2445" data-mp="1sl34md8x4xvv">
            <div className="relative z-10 transform rotate-2 md:rotate-3 transition-transform hover:rotate-0 duration-500" data-id="element-2446" data-mp="1ns9zho9jfnj9">
              <div className="bg-white/10 backdrop-blur-sm p-2 rounded-3xl border border-white/20 shadow-2xl" data-id="element-2447" data-mp="1jpww36i9k1pn">
                <img src="https://cdn.magicpatterns.com/uploads/d5jJ86NcHDRooittx54KcB/pasted-image.png" alt="App Preview" className="rounded-2xl w-full h-auto object-cover" data-id="element-2448" data-mp="1eqk281sz5udk" />
              </div>
            </div>

            {/* Floating Badges */}
            <motion.div animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-4 md:-top-6 left-0 md:left-4 bg-[#FFD700] text-[#1E2B55] px-4 py-2 rounded-xl shadow-xl font-black z-20 text-sm md:text-base" data-id="element-2449" data-mp="2z8hzbhxl4kr8">
              4.9 ★ Rating
            </motion.div>
            <motion.div animate={{
            y: [0, 8, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.5
          }} className="absolute -bottom-4 md:-bottom-6 right-0 md:right-4 bg-white text-[#1E2B55] px-4 py-2 rounded-xl shadow-xl font-black z-20 text-sm md:text-base" data-id="element-2450" data-mp="qrkptdm8g3zd">
              1M+ Downloads
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
});